export default async function jsonToCSV(options) {
    const { Parser } = await import('json2csv');
    const json2csvParser = new Parser(options);

    return json2csvParser;
}
